import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router';

import SmoothScroll from './extra/SmoothScroll';
import LoadingScreen from './extra/LoadingScreen';
import HomePage from '../js/pages/HomePage';
import SupplierDashboard from '../js/pages/Supplier/SupplierDashboard';
import SupplierReviewPage from '../js/pages/Supplier/SupplierReviewPage';
import SupplierRegisterPage from '@/js/pages/Supplier/SupplierRegisterPage';
import ProtectedRoute from './extra/ProtectedRoute';
import SupplierNavbar from '@/js/components/Navbar/SupplierNavbar';
import ManuRFQDashboard from '@/js/pages/Supplier/ManuRFQDashboard';
import RFQReview from '@/js/screens/Supplier/RFQReview';
import RFQConfirmationPage from '@/js/pages/Supplier/RFQConfirmationPage';
import BuyerProfile from '@/js/pages/Supplier/BuyerProfile';
import NDA from '@/js/screens/Supplier/ndaScreen';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const SupplierLayout = () => {
  const [isNavHidden, setIsNavHidden] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //   useEffect(() => {
  //     setTimeout(() => {
  //       setIsLoading(false);
  //     }, 700);
  //   }, []);

  return (
    <div className="flex flex-col justify-between">
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <div className={classNames('navBar', isNavHidden && 'hidden')}>
            <SupplierNavbar />
          </div>
          <div>
            <SmoothScroll>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/dashboard/review" element={<RFQReview />} />
                <Route
                  path="/dashboard/quote/confirmation"
                  element={<RFQConfirmationPage />}
                />
                <Route path="/dashboard/rfq" element={<ManuRFQDashboard />} />
                <Route path="/dashboard/nda" element={<NDA />} />
                <Route path="/dashboard/profile" element={<BuyerProfile />} />

                <Route
                  path="supplier/*"
                  element={
                    <ProtectedRoute allowedRole="supplier">
                      <Routes>
                        <Route
                          path="register"
                          element={<SupplierRegisterPage />}
                        />
                        <Route
                          path="dashboard"
                          element={<SupplierDashboard />}
                        />
                        <Route
                          path="review/:quoteNo"
                          element={<SupplierReviewPage />}
                        />
                        <Route path="rfq/:rfqId" element={<RFQReview />} />
                        <Route
                          path="*"
                          element={<Navigate to="/404" replace />}
                        />
                      </Routes>
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </SmoothScroll>
          </div>
        </>
      )}
    </div>
  );
};

export default SupplierLayout;

// import React, { useState } from 'react';
// import { Navigate, Route, Routes } from 'react-router';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

// import SupplierNavbar from '@/js/components/Navbar/SupplierNavbar';
// import SmoothScroll from './extra/SmoothScroll';
// import LoadingScreen from './extra/LoadingScreen';
// import SupplierDashboard from '../js/pages/Supplier/SupplierDashboard';
// import SupplierReviewPage from '../js/pages/Supplier/SupplierReviewPage';
// import SupplierRegisterPage from '../js/pages/Supplier/SupplierRegisterPage';
// import ProtectedRoute from './extra/ProtectedRoute';

// function classNames(...classes) {
//   return classes.filter(Boolean).join(' ');
// }

// const SupplierLayout = () => {
//   const navigate = useNavigate();
//   const { isLoggedIn, user } = useSelector((state) => state.authReducer);
//   const [isLoading, setIsLoading] = useState(false);

//   const role = user?.role;

//   // If the user isn't logged in or the role isn't 'supplier', redirect to home or role selection
//   if (!isLoggedIn || role !== 'supplier') {
//     return <Navigate to={isLoggedIn ? '/roles' : '/'} replace />;
//   }

//   return (
//     <div className="flex flex-col justify-between">
//       {isLoading ? (
//         <LoadingScreen />
//       ) : (
//         <>
//           <div>
//             <SupplierNavbar />
//           </div>
//           <div>
//             <SmoothScroll>
//               <Routes>
//                 <Route
//                   path="supplier/*"
//                   element={
//                     <ProtectedRoute allowedRole="supplier">
//                       <Routes>
//                         <Route path="register" element={<SupplierRegisterPage />} />
//                         <Route path="dashboard" element={<SupplierDashboard />} />
//                         <Route path="review/:quoteNo" element={<SupplierReviewPage />} />
//                         <Route path="*" element={<Navigate to="/404" replace />} />
//                       </Routes>
//                     </ProtectedRoute>
//                   }
//                 />
//               </Routes>
//             </SmoothScroll>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default SupplierLayout;
